import { _ } from '../utils.js'
export default class Accordion {
    constructor(el) {
        this.el = el
        this.trigger = this.el.querySelector(_('accordion-trigger').str())
        this.trigger.addEventListener('click', this.toggleAccordion)
    }

    toggleAccordion = () => {
        this.el.classList.toggle('accordion__details--open')
    }
}
